import React, { useState, useEffect } from "react";
import TablePagination from "@mui/material/TablePagination";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { styled } from "@mui/system";
import { ptBR } from "@mui/material/locale";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const CustomTablePagination = styled(TablePagination)(({ theme }) => ({
  "& .MuiTablePagination-input": {
    backgroundColor: "#455cc7",
  },
}));

const NewPaginationV2 = ({
  totalItems = 400,
  itemsPerPage = 20,
  setPagination,
  setRowsPage,
  setPageOfTable,
  pageOfTable,
}) => {
  //STATES
  const [page, setPage] = useState(pageOfTable);
  const [linesForPage, setLinesForPage] = useState(20);

  const theme = useTheme();

  const countPagination =
    parseInt(totalItems / itemsPerPage) +
    (totalItems % itemsPerPage !== 0 ? 1 : 0);

  const themeWithLocale = React.useMemo(
    () => createTheme(theme, ptBR),
    [ptBR, theme]
  );

  //USE EFFECTS
  /*
  useEffect(() => {
    console.log("41", { page, pageOfTable });
    if (pageOfTable !== null && pageOfTable !== page) {
      console.log("43", pageOfTable);
      setPage(pageOfTable);
    }
  }, [pageOfTable]);
*/
  useEffect(() => {
    setPageOfTable(page);
  }, [page]);

  useEffect(() => {
    setRowsPage(itemsPerPage);
  }, []);

  useEffect(() => {
    setPagination((page + 1) * itemsPerPage);
  }, [page, itemsPerPage]);

  useEffect(() => {
    setRowsPage(linesForPage);
  }, [linesForPage]);

  //FUNCTIONS
  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
    setPageOfTable(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setLinesForPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function defaultLabelDisplayedRows({ from, to, count }) {
    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`} itens`;
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        marginRight: "38px",
        marginBottom: "5px",
        marginTop: "5px",
      }}
    >
      <Stack spacing={2}>
        <Pagination
          id="pagination-numbers"
          count={countPagination}
          siblingCount={1}
          color="primary"
          onChange={handleChangePage}
          page={pageOfTable + 1}
        />
      </Stack>
    </div>
  );
};

export default NewPaginationV2;
